import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PaymentActions = createActionGroup({
  source: 'Payment',
  events: {
    // ── Config: fetch /api/payment-config ──────────────────────
    // Dispatched by the pricing view on activation
    'Load Config': emptyProps(),
    // Effects dispatch on fetch success
    'Load Config Success': props<{ clientToken: string; priceId: string; isSandbox: boolean }>(),
    // Effects dispatch on fetch failure
    'Load Config Failure': props<{ error: string }>(),

    // ── Has Paid: check payments table for active purchase ─────
    // Dispatched when a logged-in user opens the pricing view
    'Check Has Paid': emptyProps(),
    // Effects dispatch after Supabase query
    'Check Has Paid Success': props<{ hasPaid: boolean }>(),
    // Effects dispatch on Supabase error (treated as not-paid, logged separately)
    'Check Has Paid Failure': props<{ error: string }>(),

    // ── Verify Payment: poll payments table after checkout ─────
    // Dispatched by the /payment page on arrival with ?success=true
    'Verify Payment': emptyProps(),
    // Effects dispatch once payments table confirms completed row
    'Verify Payment Success': emptyProps(),
    // Effects dispatch after max poll attempts with no row found
    'Verify Payment Not Found': emptyProps(),
    // Effects dispatch when there is no active session to verify against
    'Verify Payment No Session': emptyProps(),
    // Effects dispatch on unexpected Supabase error
    'Verify Payment Failure': props<{ error: string }>(),
  },
});
